import {
  pipe,
  prop,
  both,
  complement,
  isNil,
  propEq,
  pathEq,
  not,
  none,
  equals,
  anyPass,
} from 'ramda';
import { compose, branch, renderNothing } from 'recompose';
import withRouter from 'react-router/lib/withRouter';
import WithShop from '../../hoc/WithShop';
import WithShops from '../../hoc/WithShops';
import withAreGcSalesDisabledForBarber from './withAreGcSalesDisabledForBarber';

const createUserTypeRouteChecker = userType => (
  pipe(
    prop('params'),
    prop(`${userType}Route`),
    complement(isNil),
  )
);

const isBrandRouteActive = createUserTypeRouteChecker('brand');
const isDisabledOnBrandPage = both(
  isBrandRouteActive,
  pipe(
    prop('shops'),
    none(
      pipe(
        prop('customerGiftCardEnabled'),
        equals(true),
      ),
    ),
  ),
);

const isShopRouteActive = createUserTypeRouteChecker('shop');
const isDisabledOnShopPage = both(
  isShopRouteActive,
  pipe(
    pathEq(['shop', 'customerGiftCardEnabled'], true),
    not,
  ),
);

const isBarberRouteActive = createUserTypeRouteChecker('barber');
const isDisabledOnBarberPage = both(
  isBarberRouteActive,
  propEq('areGcSalesDisabledForBarber', true),
);

export default compose(
  WithShop,
  WithShops,
  withRouter,
  withAreGcSalesDisabledForBarber,
  branch(
    anyPass([isDisabledOnBrandPage, isDisabledOnShopPage, isDisabledOnBarberPage]),
    renderNothing,
  ),
);



// WEBPACK FOOTER //
// ./src/app/giftCard/hoc/hideWithoutGiftCardSales.js